import React from "react";
import PageHero from "@/components/PageHero";
import Ecosystem from "@/components/sections/Ecosystem";
import WhyZopran from "@/components/sections/WhyZopran";
import TrustMetrics from "@/components/sections/TrustMetrics";
import TrustBadges from "@/components/sections/TrustBadges";
import Testimonials from "@/components/sections/Testimonials";
import CTA from "@/components/sections/CTA";
import { useT } from "@/lib/i18n";

export default function About() {
  const { t } = useT();
  return (
    <div data-testid="page-about">
      <PageHero
        eyebrow={t("nav.about")}
        title={
          <>
            {t("page.about.title.a")}{" "}
            <span className="text-[color:var(--zp-text-3)]">{t("page.about.title.b")}</span>
          </>
        }
        subtitle={t("page.about.sub")}
      />
      <TrustMetrics />
      <TrustBadges />
      <Ecosystem />
      <WhyZopran />
      <Testimonials />
      <CTA />
    </div>
  );
}
